import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import client from '../commons/utils/api-client';

function TwoFactorAuthModal(props) {
  const { visible, onCancel, form, user_uid, authCallback } = props;
  const { getFieldDecorator } = props.form;
  const [attemptsLeft, setAttemptsLeft] = useState(3);
  const [loading, setLoading] = useState(false);

  function closeModal() {
    form.resetFields();
    setAttemptsLeft(3);
    setLoading(false);
    onCancel();
  }

  async function handleSubmit(e) {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          setLoading(true);
          await client('authenticate2faToken', {
            method: 'POST',
            body: {
              user_uid: user_uid,
              token: values.token,
            },
          })
            .then(async res => {
              closeModal();
              await authCallback();
            })
            .catch(e => {
              if (attemptsLeft <= 1) {
                message.error(
                  'You have exceeded allowed attempts for this email token.  Please attempt to login again or reach out to your Admin for help.'
                );
                closeModal();
              } else {
                message.error(e.message);
                setAttemptsLeft(attemptsLeft - 1);
                setLoading(false);
              }
            });
        } catch (e) {
          setLoading(false);

          message.error(`Authentication failed: ${e.message}`);
        }
      }
    });
  }

  return (
    <Modal
      visible={visible}
      onCancel={() => {
        closeModal();
      }}
      onOk={handleSubmit}
      okButtonProps={{ loading: loading }}
      title="Two-factor Authentication"
      okText="Submit"
      centered={true}
      maskClosable={false}
      bodyStyle={{ paddingBottom: '34px' }}
    >
      <span>
        You should receive an email with a 6-digit token to enter below. If you
        cannot find the email, please contact your company Admin to update your
        saved email address or disable two-factor authentication.
      </span>
      <Form name={'two_factor_auth'}>
        <Form.Item name="token" label="Email Token" style={{ marginBottom: 0 }}>
          {getFieldDecorator('token', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: 'Token is required. ',
              },
            ],
          })(<Input />)}
        </Form.Item>
        {attemptsLeft < 3 ? (
          <span style={{ color: '#f5222d' }}>
            You have {attemptsLeft} attempts remaining.
          </span>
        ) : null}
      </Form>
    </Modal>
  );
}
export default Form.create()(TwoFactorAuthModal);
